import { Box } from '@mui/joy';
import { Dot, DotProps } from './Dot';
import { AnimationSequence, stagger, useAnimate } from 'framer-motion';
import { useEffect } from 'react';

interface DotsIndicatorProps
	extends Pick<DotProps, 'chapter' | 'diameter' | 'type'> {
	spacing?: number;
	isActive?: boolean;
	placeHolder?: boolean;
}

function useMenuAnimation(isOpen: boolean) {
	const [scope, animate] = useAnimate();

	useEffect(() => {
		const menuAnimations = isOpen
			? ([
					[
						'li',
						{ transform: 'scale(1)', opacity: 1 },
						{ delay: stagger(0.075), at: '-0.1' }
					]
					 
			  ] as AnimationSequence)
			: ([
					[
						'li',
						{ transform: 'scale(0.5)', opacity: 0 },
						{ delay: stagger(0.075, { from: 'last' }), at: '<' }
					]
					 
			  ] as AnimationSequence);

		void animate([...menuAnimations]);
	}, [isOpen, animate]);

	return scope;
}

export const DotsIndicator = ({
	diameter = '21px',
	spacing = 0.5,
	isActive = false,
	placeHolder = false,
	...props
}: DotsIndicatorProps) => {
	const diameterInt = parseInt(diameter.replace('px', ''));
	const scope = useMenuAnimation(isActive);

	return (
		<Box
			sx={{
				position: 'relative',
				width: `${parseInt(diameter.replace('px', '')) * spacing * 4}px`,
				height: diameter,
				pointerEvents: 'all'
			}}
			ref={scope}
		>
			<Box
				component={'li'}
				sx={{
					left: 0,
					top: 0,
					position: 'absolute',
					listStyle: 'none'
				}}
			>
				<Dot {...props} diameter={diameter} variant={3} />
			</Box>

			<Box
				component={'li'}
				sx={{
					left: diameterInt * spacing,
					top: 0,
					position: 'absolute',
					listStyle: 'none'
				}}
			>
				<Dot {...props} diameter={diameter} variant={2} />
			</Box>
			<Box
				component={'li'}
				sx={{
					left: diameterInt * spacing * 2,
					top: 0,
					position: 'absolute',
					listStyle: 'none'
				}}
			>
				<Dot {...props} diameter={diameter} variant={1} />
			</Box>
			{!isActive && placeHolder && (
				<Box
					sx={{
						left: diameterInt * spacing * 2,
						top: 0,
						position: 'absolute',
						listStyle: 'none'
					}}
				>
					<Dot {...props} diameter={diameter} variant={1} />
				</Box>
			)}
		</Box>
	);
};
